import { FC, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { login } from '../core/_requests'
import { useAuth } from '../core/Auth'
import { isMfaDesafio } from '../core/_models'
import { UsuarioDtoLogin } from '../core/_models'
import { Button, FormInput, LoadingIndicator, useModal } from '../../../components'
import { ButtonType, PlataformaType, showError } from '../../../../_metronic/helpers'

const unlockSchema = Yup.object().shape({
  senha: Yup.string().required('Informe sua senha para continuar'),
})

type SessionLockModalContentProps = {
  onUnlock: () => void
}

export const SessionLockModalContent: FC<SessionLockModalContentProps> = ({ onUnlock }) => {
  const { currentUser, saveAuth, logout } = useAuth()
  const { closeModal } = useModal()
  const [loggingOut, setLoggingOut] = useState(false)

  const handleLogout = async () => {
    setLoggingOut(true)
    try {
      await logout()
    } finally {
      closeModal()
    }
  }

  const formik = useFormik({
    initialValues: { senha: '' },
    validationSchema: unlockSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true)
      try {
        const credentials: UsuarioDtoLogin = {
          email: currentUser?.email ?? '',
          senha: values.senha,
          plataforma: PlataformaType.Site,
        }
        const resposta = await login(credentials)
        if (isMfaDesafio(resposta)) {
          resetForm()
          await logout()
          return
        }
        saveAuth(resposta)
        resetForm()
        onUnlock()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate autoComplete='off'>
      <div className='text-gray-600 fw-semibold fs-6 mb-6'>
        Sua sessão foi bloqueada por inatividade. Informe sua senha para continuar de onde parou.
      </div>

      <div className='mb-6'>
        <div className='fw-semibold text-gray-700'>Usuário</div>
        <div className='fw-bold text-gray-800'>{currentUser?.email}</div>
      </div>

      <FormInput
        formik={formik}
        type='password'
        name='senha'
        label='Senha'
        placeholder='Digite sua senha'
        isRequired
        autoComplete='new-password'
      />

      <div className='d-flex justify-content-between mt-6'>
        <Button
          onClick={handleLogout}
          className='btn-secondary'
          disabled={formik.isSubmitting || loggingOut}
        >
          {loggingOut ? <LoadingIndicator /> : 'Encerrar sessão'}
        </Button>
        <Button
          type={ButtonType.Submit}
          className='btn-primary'
          disabled={formik.isSubmitting || loggingOut}
        >
          {formik.isSubmitting ? <LoadingIndicator /> : 'Desbloquear'}
        </Button>
      </div>
    </form>
  )
}
